/**
 * Phase 7.1 — Frontend Data Contract Adapter
 *
 * Purpose:
 * - Enforce a single, explicit consumption path for output_contract
 * - Prevent parsing drift across components
 * - Guarantee read-only semantics
 *
 * Rules:
 * - No calculations
 * - No defaults
 * - No fallbacks
 * - No renaming
 * - No mutation
 */

export function adaptOutputContract(outputContract) {
  if (!outputContract || typeof outputContract !== "object") {
    return null;
  }

  return deepFreeze(outputContract);
}

function deepFreeze(obj) {
  if (obj === null || typeof obj !== "object") return obj;

  Object.freeze(obj);

  Object.getOwnPropertyNames(obj).forEach((prop) => {
    if (
      obj[prop] !== null &&
      (typeof obj[prop] === "object" || typeof obj[prop] === "function") &&
      !Object.isFrozen(obj[prop])
    ) {
      deepFreeze(obj[prop]);
    }
  });

  return obj;
}
